import React from "react";
import { useRef, useState, useEffect } from "react";
import Select, { Creatable } from "react-select";
import { defaultDropdownStyle, newChatDropdownStyle } from "./DropdownStyles";
import { selectMenuStyle } from "aible/CustomStyles/DropdownStyles";
import { isOptionType } from "utils/select";
const DynamicWidthSelector = ({ menuPlacement, className, style, isNewChat, isDynamic, isStyled, value, options, placeholder, onChange, components, color, isCreatable, isSearchable, isMulti, isClearable, label, isDisabled, innerRef, maxMenuHeight, ...retProps }) => {
    const textRef = useRef(null);
    const [newWidth, setNewWidth] = useState("100px");
    useEffect(() => {
        const textWidth = textRef?.current?.clientWidth;
        if (isDynamic && textWidth !== undefined) {
            const textOffset = isNewChat ? 53 : 46;
            setNewWidth(`${textWidth + textOffset}px`);
        }
    }, [value ?? placeholder]);
    const dynamicWidthStyle = {
        control: (baseStyles) => ({
            ...baseStyles,
            border: 0,
            backgroundColor: "transparent",
            boxShadow: "none",
            cursor: "pointer",
            width: newWidth
        })
    };
    const combinedStyles = !isStyled && !isNewChat && !isDynamic
        ? selectMenuStyle
        : {
            ...(isStyled ? defaultDropdownStyle(color) : null),
            ...(isNewChat ? newChatDropdownStyle(color) : null),
            ...(isDynamic ? dynamicWidthStyle : null)
        };
    const SelectComponent = (isCreatable ? Creatable : Select);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: textRef, style: {
                fontSize: isNewChat ? "30px" : "13px",
                height: "0",
                overflow: "hidden",
                position: "absolute",
                whiteSpace: "nowrap",
                ...style
            } }, !isOptionType(value) ? placeholder : (value?.label ?? placeholder)),
        React.createElement("div", { className: className, style: style },
            React.createElement(SelectComponent, { options: options, value: value, onChange: onChange, placeholder: placeholder, menuPlacement: menuPlacement ?? "top", components: components, styles: combinedStyles, isSearchable: isSearchable, isMulti: isMulti, isClearable: isClearable, label: label, isDisabled: isDisabled, maxMenuHeight: maxMenuHeight ?? 200, ...retProps, ref: innerRef }))));
};
export default DynamicWidthSelector;
